






















































import Vue from 'vue'
import { StatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import mixin from './cardmixin.vue'
const ssp = new StatisticsServiceProxy()

export default Vue.extend({
  name: 'threshold-rate-table',
  mixins: [mixin],
  data() {
    return {
      data: [],
      badgeStatus: [],
      loading: false
    }
  },
  mounted() {
    this.getList('')
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_card_workstation_code'),
          key: 'workStationCode',
          dataIndex: 'workStationCode',
          ellipsis: true,
          width: 100
        },
        {
          title: this.$t('page_mdc_customer_name'),
          key: 'customerName',
          dataIndex: 'customerName',
          scopedSlots: { customRender: 'customerName' },
          ellipsis: true,
          width: 260
        },
        {
          title: this.$t('page_mdc_one_week_ago'),
          key: 'lastPeriodValue',
          dataIndex: 'lastPeriodValue',
          ellipsis: true
        },
        {
          title: this.$t('page_mdc_two_week_ago'),
          key: 'last2rdPeriodValue',
          dataIndex: 'last2rdPeriodValue',
          ellipsis: true
        },
        {
          title: this.$t('page_mdc_change_two_week'),
          key: 'nearly2WeeksPeriodValue',
          dataIndex: 'nearly2WeeksPeriodValue',
          scopedSlots: { customRender: 'nearly2WeeksPeriodValue' },
          ellipsis: true,
          width: 180
        }
      ]
    }
  },
  methods: {
    navTo(keyWord) {
      this.ViewMOre('screening-customers-table', {keyWord});
    },
    getList(threshold) {
      this.loading = true
      const dto: any = {
        areaNameList: [],
        customerIdList: [],
        deviceTypeIdList: [],
        endDate: '',
        regionNameList: [],
        startDate: '',
        threshold: threshold
      }
      ssp
        .getWeeklyEfficiencyData(1, dto, -1)
        .then((res) => {
          this.data = res.records
          this.checkScrollY('threshold-rate', this.data.length)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    changeInput(value) {
      this.getList(value)
    }
  }
})
